import React, { useCallback, useEffect } from 'react';
import './MyAccountV2.scss';
import MyAccountHeader from './MyAccountHeader';
import MyAccountNavigation from './MyAccountTabs';
import { useMyAccountTabs } from './MyAccountTabs/useMyAccountTabs';
import SettingsTab from "./MyAccountTabs/SettingsTab";
import DocumentsTab from "./MyAccountTabs/DocumentsTab";
import EcardTab from "./MyAccountTabs/EcardTab";
import TicketsTab from "./MyAccountTabs/TicketsTab";
import ReservationsTab from "./MyAccountTabs/ReservationsTab";
import PeopleTab from "./MyAccountTabs/PeopleTab";
import { useLocation, useNavigate } from 'react-router';
import qs from 'qs';
import { useSelector } from 'react-redux';
import { goToPreviousPage } from '../../../utils/goToPreviousPage';
import { LOGIN_PAGE } from '../../routes';
import { State } from '../../store';
import { TabType } from './MyAccountTabs/consts';
import { mergeSearchWithTab, resolveTabFromQuery } from '../../../utils/myAccountTabUrl';

const MyAccountV2: React.FC = () => {
  const { activeTab, setActiveTab } = useMyAccountTabs();
  const navigate = useNavigate();
  const location = useLocation();
  const allowSubaccounts = useSelector((state: State) => state.config.configuration.allowSubaccounts === true);
  const ecardShowCode = useSelector((state: State) => state.config.configuration.ecard_showCode);

  useEffect(() => {
    const queryParams = qs.parse(window.location.search.slice(1));
    if (queryParams.redirect === "previousPath") {
      goToPreviousPage(navigate, LOGIN_PAGE);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const resolved = resolveTabFromQuery(location.search, {
      allowSubaccounts,
      ecardShowCode: !!ecardShowCode,
    });
    if (resolved) {
      setActiveTab(resolved);
    }
  }, [location.search, allowSubaccounts, ecardShowCode, setActiveTab]);

  const handleTabChange = useCallback(
    (tab: TabType) => {
      setActiveTab(tab);
      const next = mergeSearchWithTab(location.search, tab);
      navigate(`${location.pathname}?${next}`, { replace: true });
    },
    [location.pathname, location.search, navigate, setActiveTab],
  );

  const getTabComponent = () => {
    switch (activeTab) {
      case "documents":
        return <DocumentsTab />;
      case "settings":
        return <SettingsTab />;
      case "ecard":
        return <EcardTab />;
      case "tickets":
        return <TicketsTab />;
      case "reservations":
        return <ReservationsTab />;
      case "people":
        return <PeopleTab />;
    }
    return <p>Placeholder dla: {activeTab}</p>;
  };

  return (
    <div className="my-account-v2">
      <MyAccountHeader />
      <MyAccountNavigation activeTab={activeTab} onTabChange={handleTabChange} />
      <div className="my-account-v2__content">{getTabComponent()}</div>
    </div>
  );
};

export default MyAccountV2;
